/**
 * Mirrors backend RegDataNormalization.TryGetBoolValue for values that may
 * round-trip through JSON as bool, string, or number.
 */
export function tryGetBoolValue(raw: unknown): { success: true; value: boolean } | { success: false } {
    if (raw == null) {
        return { success: false };
    }

    if (typeof raw === "boolean") {
        return { success: true, value: raw };
    }

    if (typeof raw === "string") {
        const normalized = raw.trim().toLowerCase();
        if (normalized === "true") return { success: true, value: true };
        if (normalized === "false") return { success: true, value: false };
        return { success: false };
    }

    if (typeof raw === "number" && (raw === 0 || raw === 1)) {
        return { success: true, value: raw === 1 };
    }

    return { success: false };
}

export function tryGetBool(values: Record<string, unknown> | undefined, key: string): boolean | undefined {
    if (!values || !(key in values)) {
        return undefined;
    }

    const parsed = tryGetBoolValue(values[key]);
    return parsed.success ? parsed.value : undefined;
}

/** False when the key is absent or not coercible to bool. */
export function getBoolOrFalse(values: Record<string, unknown> | undefined, key: string): boolean {
    return tryGetBool(values, key) ?? false;
}
